import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-4ec2d1d7"), n = n(), _popScopeId(), n); };
var _hoisted_1 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "background" }, null, -1); });
var _hoisted_2 = { class: "container" };
var _hoisted_3 = { class: "flex justify-between min-w-0 items-center" };
var _hoisted_4 = { class: "flex items-center" };
var _hoisted_5 = {
    key: 0,
    class: "font-bold text-center truncate lg:hidden"
};
var _hoisted_6 = { class: "flex items-stretch" };
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { CoreStore } from '@student/modules/store';
import NotificationsSocketPanel from '@common/components/Notifications/NotificationsSocketPanel.vue';
import NotificationsPanel from '@common/components/Notifications/NotificationsPanel.vue';
import EIcon from '@common/ui/EIcon.vue';
import EDropdown from '@common/ui/EDropdown/EDropdown.vue';
import { useGetAllNotificationsQuery } from '@common/graphql/operations';
import Auth from '@common/modules/auth';
import { isMobile } from '@common/utils/Crossbrowser';
import { useMeta } from '@common/hooks/useMeta';
import { useI18n } from "vue-i18n";
import { getAndroidApplicationVersion, isAndroidApp } from "@common/utils/MobileApp";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TopNav',
    props: {
        isLesson: { type: Boolean, default: false },
        isCourseLearn: { type: Boolean, default: false }
    },
    setup: function (__props) {
        var t = useI18n().t;
        var props = __props;
        var route = useRoute();
        var router = useRouter();
        var school = computed(function () { return CoreStore.school; });
        var isNotificationsOpen = ref(false);
        var isAndroid = isAndroidApp();
        var isNewAndroidApp = getAndroidApplicationVersion();
        var isNeedPadding = computed(function () { return isAndroid && !isNewAndroidApp; });
        var isGuest = computed(function () { return Auth.isGuest(); });
        var notifications = useGetAllNotificationsQuery(function () { return ({
            pagination: {
                skip: 0,
                take: 20,
            }
        }); }, { enabled: !isGuest.value }).result;
        var isHasNewNotifications = computed(function () { var _a; return !!((_a = notifications.value) === null || _a === void 0 ? void 0 : _a.notificationsCount.find(function (item) { return item.countUnread > 0; })); });
        var isSchoolCourses = computed(function () { return route.name === 'schoolCourses'; });
        var title = useMeta().title;
        /**
         * Определение заголовка страницы
         */
        var pageTitle = computed(function () {
            if (isNotificationsOpen.value) {
                return t('page.notifications');
            }
            return title.value;
        });
        watch(route, function () {
            if (isMobile()) {
                isNotificationsOpen.value = false;
            }
        }, { deep: true });
        /**
         * Отображаем ли кнопку назад:
         * Логика:
         * - Если текущий маршрут — 'schoolCourses', вверх идти некуда, не показываем стрелку.
         * - Иначе всегда показываем стрелку (так как либо есть parentRoute, либо fallback на schoolCourses).
         */
        var showBackIcon = computed(function () {
            return !isSchoolCourses.value;
        });
        var handleArrowClick = function () {
            if (isNotificationsOpen.value) {
                isNotificationsOpen.value = false;
                return;
            }
            var parentRouteName = route.meta.parentRoute;
            if (parentRouteName) {
                // Идём на родительский маршрут
                router.push({ name: parentRouteName });
            }
            else {
                // Нет родительского роута в метаданных
                // Если мы не на schoolCourses, поднимаемся к schoolCourses
                if (!isSchoolCourses.value) {
                    router.push({ name: 'schoolCourses' });
                }
                // Если уже на schoolCourses - стрелка назад не отображается, так что сюда не попадём
            }
        };
        return function (_ctx, _cache) {
            var _component_e_button = _resolveComponent("e-button");
            var _component_e_link = _resolveComponent("e-link");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([
                    'top-nav',
                    { 'top-nav--app': isNeedPadding.value }
                ])
            }, [
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            (showBackIcon.value)
                                ? (_openBlock(), _createBlock(_component_e_button, {
                                    key: 0,
                                    class: "-my-2",
                                    size: "nosize",
                                    type: "transparent",
                                    onClick: handleArrowClick
                                }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(EIcon, {
                                            class: "w-3 h-4 text-gray-400 cursor-pointer",
                                            icon: "arrow-left"
                                        })
                                    ]; }),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ]),
                        (pageTitle.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(pageTitle.value), 1))
                            : _createCommentVNode("", true),
                        (!isNotificationsOpen.value)
                            ? (_openBlock(), _createBlock(NotificationsSocketPanel, {
                                key: 1,
                                "school-id": school.value.id
                            }, null, 8, ["school-id"]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(EDropdown, {
                                visible: isNotificationsOpen.value,
                                "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) { return ((isNotificationsOpen).value = $event); }),
                                "allowed-placements": ['bottom-end'],
                                "offset-amount": 17,
                                trigger: "click",
                                fullwidth: ""
                            }, {
                                default: _withCtx(function () { return [
                                    (_unref(isMobile)() && !isNotificationsOpen.value)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: _normalizeClass([[isNotificationsOpen.value && 'bg-gray-200 text-dark/80'], "rounded-lg cursor-pointer hover:bg-gray-200 flex justify-center items-center text-dark/40"])
                                        }, [
                                            (isHasNewNotifications.value)
                                                ? (_openBlock(), _createBlock(EIcon, {
                                                    key: 0,
                                                    class: "new-notifications-icon w-5 h-5",
                                                    icon: "bicolor/bell-with-circle"
                                                }))
                                                : (_openBlock(), _createBlock(EIcon, {
                                                    key: 1,
                                                    class: "w-5 h-5",
                                                    icon: "notifications/notification"
                                                }))
                                        ], 2))
                                        : _createCommentVNode("", true),
                                    (isNotificationsOpen.value && _unref(isMobile)())
                                        ? (_openBlock(), _createBlock(_component_e_link, {
                                            key: 1,
                                            "href-to": { name: 'profileNotifications' },
                                            class: "group flex items-center",
                                            type: "transparent"
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(EIcon, {
                                                    class: "opacity-30 w-[18px] h-[18px] group-hover:opacity-80 duration-200",
                                                    icon: "notifications/notification-settings"
                                                })
                                            ]; }),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true)
                                ]; }),
                                overlay: _withCtx(function () { return [
                                    _createVNode(NotificationsPanel, {
                                        "school-id": school.value.id
                                    }, null, 8, ["school-id"])
                                ]; }),
                                _: 1
                            }, 8, ["visible"])
                        ])
                    ])
                ])
            ], 2));
        };
    }
});
